/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "./views/Dashboard.js";
import Icons from "./views/Icons.js";
import Map from "./views/Map.js";
import Notifications from "./views/Notifications.js";
import Rtl from "./views/Rtl.js";
import TableList from "./views/TableList.js";
import Typography from "./views/Typography.js";
import UserProfile from "./views/UserProfile.js";
import CheckOut from "./views/Checkout.js";
import Login from "./views/Login.js";
import Comprobantes from "./views/Comprobantes.js";
import Detalle from "./views/DetalleComprobantePDF.js";
import PDF from "./views/DetalleComprobantePDF.js";

var routes = [
  {
    path: "/dashboard",
    name: "Crear Nómina",
    rtlName: "لوحة القيادة",
        icon: "tim-icons icon-paper",
        component: CheckOut,
    layout: "/admin",
  },
  {
    path: "/icons",
    name: "Empleados",
    rtlName: "الرموز",
      icon: "tim-icons icon-badge",
    component: Icons,
    layout: "/admin",
  },
  /*{
    path: "/map",
    name: "Map",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    component: Map,
    layout: "/admin",
  },*/
  {
    path: "/notifications",
    name: "Comprobantes",
    rtlName: "إخطارات",
      icon: "tim-icons icon-single-copy-04",
      component: Comprobantes,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "Configuracion",
    rtlName: "ملف تعريفي للمستخدم",
      icon: "tim-icons icon-atom",
    component: UserProfile,
    layout: "/admin",
    },/*,
  {
    path: "/tables",
    name: "Negociaciones",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-puzzle-10",
    component: TableList,
    layout: "/admin",
  },*/
  {
    path: "/Login",
    name: "Salir",
    rtlName: "طباعة",
      icon: "tim-icons icon-button-power",
    component: Login,
    layout: "/admin",
    },
    
  {/*
    path: "/comprobante",
    name: "PDF Detalle",
    rtlName: "ار تي ال",
      icon: "tim-icons icon-world",
      component: PDF,
      layout: "/admin",
  */}
];
export default routes;
